import React, { Fragment, useEffect, useState } from 'react';
import Common from '../../../Shared/Common';
import { Container, Row, Col } from 'reactstrap';

import './../Resources/css/block_aboutUs.css'

import Block from '../../../Controls/Scafolding/Block';
import { Button } from 'bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleLeft, faFish } from '@fortawesome/free-solid-svg-icons';
import { TextHeader, TextTitle, TextBock } from '../../../Controls/Digital/TextHeaders';

import img_icon from '../Resources/Images/Logo-sample-4.png';
import img_1 from '../Resources/Images/product_sample_10.jpg';
import img_2 from '../Resources/Images/product_sample_9.jpg';
import img_3 from '../Resources/Images/product_sample_4.avif';
import img_4 from '../Resources/Images/product_sample_5.avif';
import img_5 from '../Resources/Images/product_sample_12.jpg';
import img_6 from '../Resources/Images/product_sample_11.jpg';
import { AnimatedImage, ImageTextOverlay } from '../../../Controls/Digital/AnimatedImage';

const AboutUs = (props) => {

    const [blockName, setBlockName] = useState("");

    return (

        <Block name="aboutUs" isAlt={true}>

            <TextHeader text={
                <Fragment>
                    Freshly baked from our Oven to your kitchen
                </Fragment>
            } />

            <Row>
                <Col lg="12" className="text-center">
                    <img src={img_icon} className="img-fluid" />
                </Col>
            </Row>

            <Row>
                <Col lg="4" className="about-photo-frame img-text-container">
                    <AnimatedImage image={img_5} animation="point-zoom" />
                    <ImageTextOverlay location="centered" text={
                        <Fragment>
                            Handcrafted
                        </Fragment>
                    } />
                </Col>
                <Col lg="4" className="about-photo-frame img-text-container">
                    <AnimatedImage image={img_1} animation="slowmo" />
                    <ImageTextOverlay location="centered" addClass="nd-style" text={
                        <Fragment>
                            Tradicion
                        </Fragment>
                    } />
                </Col>
                <Col lg="4" className="about-photo-frame img-text-container">
                    <AnimatedImage image={img_6} animation="brightness" />
                    <ImageTextOverlay location="centered" text={
                        <Fragment>
                            Natural
                        </Fragment>
                    } />
                </Col>

                <Col lg="8" className="about-photo-frame about-text">
                    <Container>
                        <TextTitle text={
                            <Fragment>
                                You can't buy happiness, but you can bake it !!!!
                            </Fragment>
                        } />

                        <TextBock addClass="left-text" text={
                            <Fragment>
                                Here at The Gwynneville Bakery, quality food is our passion. We use only the finest and freshest ingredients to create your lunch and/or dinner, together with our unsurpassed customer service that will keep you coming back!
                            </Fragment>
                        } />


                        <TextBock addClass="left-text" text={
                            <Fragment>
                                The Gwynneville Gourmet Bakery, as it was named, has been established since 1990. In its cosy, but comfortable space, it catered to the local community of Gwynneville. Like all good businesses, it outgrew its surroundings and in 2013 it expanded into the premises you see today.
                            </Fragment>
                        } />

                        <TextBock addClass="left-text" text={
                            <Fragment>
                                Based on Parisian pattisserie, the surroundings are both warm and inviting, and comfortable and spacious, where you can enjoy a cup of award winning coffee and a cake or pastry from a wide selection, or treat your tastebuds to a nutritious and filling lunch. Our quiches and vegan pies are second to none, not to mention our tasty sandwich menu and salad bar. 
                            </Fragment>
                        } />

                        <TextBock addClass="left-text" text={
                            <Fragment>
                                We love to cook food fresh on a daily basis, and our highest priority is satisfying each and every one of our customers. 
                                Based on Parisian pattisserie, the surroundings are both warm and inviting, and comfortable and spacious, where you can enjoy a cup of award winning coffee and a cake or pastry from a wide selection, or treat your tastebuds to a nutritious and filling lunch. Our quiches and vegan pies are second to none, not to mention our tasty sandwich menu and salad bar. 
                            </Fragment>
                        } />

                        <TextBock addClass="left-text" text={
                            <Fragment>
                                Try our selection of:
                                <ul>
                                    <li>
                                        Sourdough, Vienna & White breads
                                    </li>
                                    <li>
                                        White & Dark Sourdoughs
                                    </li>
                                    <li>
                                        Danish, Croissants...
                                    </li>
                                    <li>
                                        Cakes
                                    </li>
                                </ul>
                            </Fragment>
                        } />

                    </Container>
                </Col>

                <Col lg="4" className="about-photo-frame">
                    <AnimatedImage image={img_2} animation="colorize" />
                </Col>

            </Row>

        </Block>

    );
};
export default AboutUs;


